import PortalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib';
import experiments from '../../../experiments.yaml';
let laboratoryClient;
export const createLaboratoryClient = ({
  userId
} = {}) => {
  if (!laboratoryClient) {
    const portalId = PortalIdParser.get();
    laboratoryClient = createClient({
      name: 'LearningCenterUI',
      experiments: experiments,
      identifiers: {
        portalId,
        userId
      }
    });
  }
  return laboratoryClient;
};
export const TreatmentsClient = {
  get() {
    if (!laboratoryClient) {
      laboratoryClient = createLaboratoryClient();
    }
    return laboratoryClient;
  }
};
export const getLaboratoryClient = () => laboratoryClient;